var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { getByIdAPI, getListAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { ActiveContractURL, ContractInvoiceKeys, contractSaleOrderGet, CSIPagingAPI, customerDetailsGet, ExecutiveListAPI, GetServiceContractDetailsURL, InstallBaseListURL, invoiceSaleCountURL, NewContractURL, PaymentModeListURL, paymentTermListURL, paymentTypeListURL, searchByMobNoURL, searchByOrderNoURL } from "./entity";
var dispatch = store.dispatch;
export var executiveListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _params$request, _res$payload, _a, key, _b, url, _c, request, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.ExecutiveListKey : _a, _b = params.url, url = _b === void 0 ? ExecutiveListAPI(params === null || params === void 0 || (_params$request = params.request) === null || _params$request === void 0 ? void 0 : _params$request.OrganizationId) : _b, _c = params.request, request = _c === void 0 ? {} : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var paymentModeListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.PaymentModeListKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? PaymentModeListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var paymentTypeListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.PaymentTypeListKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? paymentTypeListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
        }
    });
}); };
export var paymentTermListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload4, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.PaymentTermListKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? paymentTermListURL : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.value];
        }
    });
}); };
export var ContractSaleInvoicePagingAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload5, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.Paging : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? CSIPagingAPI : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload5 = res.payload) === null || _res$payload5 === void 0 ? void 0 : _res$payload5.value];
        }
    });
}); };
export var InstallBaseListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload6, _a, key, _b, url, _c, request, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.InstallBaseListKey : _a, _b = params.url, url = _b === void 0 ? InstallBaseListURL : _b, _c = params.request, request = _c === void 0 ? {} : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload6 = res.payload) === null || _res$payload6 === void 0 ? void 0 : _res$payload6.value];
        }
    });
}); };
export var GetContractSaleDetailsAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _params$request2, _res$payload7, _a, key, _b, url, _c, request, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.GetServiceContractDetailsKey : _a, _b = params.url, url = _b === void 0 ? GetServiceContractDetailsURL(params === null || params === void 0 || (_params$request2 = params.request) === null || _params$request2 === void 0 ? void 0 : _params$request2.id) : _b, _c = params.request, request = _c === void 0 ? {} : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload7 = res.payload) === null || _res$payload7 === void 0 ? void 0 : _res$payload7.value];
        }
    });
}); };
export var searchByMobileNoAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload8, _a, key, _b, url, _c, request, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.SearchByMobNoKey : _a, _b = params.url, url = _b === void 0 ? searchByMobNoURL : _b, _c = params.request, request = _c === void 0 ? {} : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload8 = res.payload) === null || _res$payload8 === void 0 ? void 0 : _res$payload8.value];
        }
    });
}); };
export var searchByOrderNoAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload9, _a, key, _b, url, _c, request, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.SearchByOrderNo : _a, _b = params.url, url = _b === void 0 ? searchByOrderNoURL : _b, _c = params.request, request = _c === void 0 ? {} : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload9 = res.payload) === null || _res$payload9 === void 0 ? void 0 : _res$payload9.value];
        }
    });
}); };
export var getContractSaleOrderAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload10, _res$payload11, _activeContractRes$pa, _newContractRes$paylo, _res$payload12, _res$payload13, _customerGet$payload, _a, key, _b, request, _c, url, res, customerGet, activeContractRes, newContractRes, updatedActiveContracts, updatedNewContracts, firstVehicle, response;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.getCSI : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? contractSaleOrderGet(request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                customerGet = dispatch(getByIdAPI({
                    key: ContractInvoiceKeys.CustomerDetailsKey,
                    url: customerDetailsGet(res === null || res === void 0 || (_res$payload10 = res.payload) === null || _res$payload10 === void 0 || (_res$payload10 = _res$payload10.value) === null || _res$payload10 === void 0 || (_res$payload10 = _res$payload10.data) === null || _res$payload10 === void 0 ? void 0 : _res$payload10.CustomerId),
                    request: {}
                }));
                return [4 /*yield*/, dispatch(getListAPI({
                        key: ContractInvoiceKeys.ActiveContracts,
                        url: ActiveContractURL,
                        request: {
                            InstallBaseId: res === null || res === void 0 || (_res$payload11 = res.payload) === null || _res$payload11 === void 0 || (_res$payload11 = _res$payload11.value) === null || _res$payload11 === void 0 || (_res$payload11 = _res$payload11.data) === null || _res$payload11 === void 0 || (_res$payload11 = _res$payload11.VehicleContractDetails[0]) === null || _res$payload11 === void 0 ? void 0 : _res$payload11.InstallBaseId
                        }
                    }))];
            case 2:
                activeContractRes = _d.sent();
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: ContractInvoiceKeys.NewContractKey,
                        url: NewContractURL,
                        request: {}
                    }))];
            case 3:
                newContractRes = _d.sent();
                updatedActiveContracts = (activeContractRes === null || activeContractRes === void 0 || (_activeContractRes$pa = activeContractRes.payload) === null || _activeContractRes$pa === void 0 || (_activeContractRes$pa = _activeContractRes$pa.value) === null || _activeContractRes$pa === void 0 || (_activeContractRes$pa = _activeContractRes$pa.data) === null || _activeContractRes$pa === void 0 ? void 0 : _activeContractRes$pa.map(function (contract) {
                    var _contract$ContractPri, _contract$Price, _contract$ContractPri2, _contract$ContractPri3;
                    return _objectSpread(_objectSpread({}, contract), {}, {
                        ContractPrice: (_contract$ContractPri = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri !== void 0 ? _contract$ContractPri : 0,
                        Rate: (_contract$Price = contract === null || contract === void 0 ? void 0 : contract.Price) !== null && _contract$Price !== void 0 ? _contract$Price : 0,
                        DiscountPercentage: 0,
                        DiscountAmount: 0,
                        ChargesAmount: 0,
                        TaxableAmount: (_contract$ContractPri2 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri2 !== void 0 ? _contract$ContractPri2 : 0,
                        UnitOfMeasurementId: null,
                        PostingTypeId: null,
                        TotalAmount: (_contract$ContractPri3 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri3 !== void 0 ? _contract$ContractPri3 : 0,
                        Quantity: 1,
                        SGST_UTGST_Percentage: 0,
                        SGST_UTGST_Amount: 0,
                        CGSTAmount: 0,
                        CGSTPercentage: 0,
                        IGSTAmount: 0,
                        IGSTPercentage: 0,
                        EntityId: contract === null || contract === void 0 ? void 0 : contract.EntityId,
                        ChildId: contract === null || contract === void 0 ? void 0 : contract.ChildId
                    });
                })) || [];
                updatedNewContracts = (newContractRes === null || newContractRes === void 0 || (_newContractRes$paylo = newContractRes.payload) === null || _newContractRes$paylo === void 0 || (_newContractRes$paylo = _newContractRes$paylo.value) === null || _newContractRes$paylo === void 0 || (_newContractRes$paylo = _newContractRes$paylo.data) === null || _newContractRes$paylo === void 0 ? void 0 : _newContractRes$paylo.map(function (contract) {
                    var _contract$ContractPri4, _contract$ContractPri5, _contract$ContractPri6, _contract$ContractPri7;
                    return _objectSpread(_objectSpread({}, contract), {}, {
                        ContractPrice: (_contract$ContractPri4 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri4 !== void 0 ? _contract$ContractPri4 : 0,
                        Rate: (_contract$ContractPri5 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri5 !== void 0 ? _contract$ContractPri5 : 0,
                        DiscountPercentage: 0,
                        DiscountAmount: 0,
                        ChargesAmount: 0,
                        TaxableAmount: (_contract$ContractPri6 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri6 !== void 0 ? _contract$ContractPri6 : 0,
                        UnitOfMeasurementId: null,
                        PostingTypeId: null,
                        TotalAmount: (_contract$ContractPri7 = contract === null || contract === void 0 ? void 0 : contract.ContractPrice) !== null && _contract$ContractPri7 !== void 0 ? _contract$ContractPri7 : 0,
                        Quantity: 1,
                        SGST_UTGST_Percentage: 0,
                        SGST_UTGST_Amount: 0,
                        CGSTAmount: 0,
                        CGSTPercentage: 0,
                        IGSTAmount: 0,
                        IGSTPercentage: 0,
                        SystemName: 'ServiceContract',
                        ChildId: contract === null || contract === void 0 ? void 0 : contract.id
                    });
                })) || [];
                firstVehicle = res === null || res === void 0 || (_res$payload12 = res.payload) === null || _res$payload12 === void 0 || (_res$payload12 = _res$payload12.value) === null || _res$payload12 === void 0 || (_res$payload12 = _res$payload12.data) === null || _res$payload12 === void 0 ? void 0 : _res$payload12.VehicleContractDetails[0];
                response = _objectSpread(_objectSpread(_objectSpread({}, res === null || res === void 0 || (_res$payload13 = res.payload) === null || _res$payload13 === void 0 || (_res$payload13 = _res$payload13.value) === null || _res$payload13 === void 0 ? void 0 : _res$payload13.data), customerGet === null || customerGet === void 0 || (_customerGet$payload = customerGet.payload) === null || _customerGet$payload === void 0 || (_customerGet$payload = _customerGet$payload.value) === null || _customerGet$payload === void 0 ? void 0 : _customerGet$payload.data), {}, {
                    ActiveContracts: updatedActiveContracts,
                    NewContracts: updatedNewContracts,
                    selectedVehicle: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.RegistrationNo,
                    SelectedButton: 'New',
                    EngineNo: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.EngineNo,
                    VinNo: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.VinNo,
                    RegistrationNo: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.RegistrationNo,
                    ModelName: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.ModelName,
                    SalesInvoiceDate: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.SalesInvoiceDate,
                    ProductName: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.ProductName,
                    ProductCode: firstVehicle === null || firstVehicle === void 0 ? void 0 : firstVehicle.ProductCode
                });
                return [2 /*return*/, {
                        data: response,
                        success: true
                    }];
        }
    });
}); };
export var getCustomerDetailsAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload14, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.CustomerDetailsKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? customerDetailsGet(request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload14 = res.payload) === null || _res$payload14 === void 0 ? void 0 : _res$payload14.value];
        }
    });
}); };
export var InvoiceCountAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload15, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? ContractInvoiceKeys.ContractSaleInvoiceCount : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? invoiceSaleCountURL : _c;
                return [4 /*yield*/, dispatch(getListAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload15 = res.payload) === null || _res$payload15 === void 0 ? void 0 : _res$payload15.value];
        }
    });
}); };
